module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAADAQMAAACQ8ww2AAAABlBMVEX///////9VfPVsAAAAAXRSTlPI1VmS5AAAAA9JREFUCNdjAIL/BxjqGwAJggK/vo6a5wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/dash.png
// module id = 316
// module chunks = 0